import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const FINISHING_OPTIONS_FILTER = (isFinishing: boolean | undefined, kind?: string) => {
  const url = () => {
    return isFinishing || isFinishing === undefined
      ? kind
        ? `/api/crm/classifier_groups/?kind=${kind}`
        : '/api/crm/classifier_groups/'
      : kind
        ? `/api/crm/classifier_groups/?finishing_flag=WITHOUT_FINISHING&kind=${kind}`
        : '/api/crm/classifier_groups/?finishing_flag=WITHOUT_FINISHING';
  };

  return {
    label: 'Опции',
    name: 'classifier_groups',
    type: FILTER_TYPE.SELECT,
    mode: 'multiple',
    apiUrl: url(),
  };
};
